import { apiClient } from '../../../Utilities/apiClient';
import { Country, City } from '../../../Resources/Data/Locations';

export const locationFilterService = {
  // Get all countries for filtering
  getCountries: async (): Promise<Country[]> => {
    const response = await apiClient.get('/trails/locations/countries');
    return response.data.countries || [];
  },

  // Get cities by country for filtering
  getCitiesByCountry: async (countryId: number): Promise<City[]> => {
    const response = await apiClient.get(`/trails/locations/countries/${countryId}/cities`);
    return response.data;
  },

  // Get all cities for filtering
  getAllCities: async (): Promise<City[]> => {
    const response = await apiClient.get('/trails/locations/cities');
    return response.data.cities || [];
  },
};
